import { I18n } from '@calendly/i18n';
import { LabelText } from '@calendly/ui/components/typography';
const todayBadgeCss = "thu4u1y";

/**
 * Renders a "Today" badge for a meeting group.
 *
 * Displays a small label with the translated text "Today" in a styled container.
 * This is used to indicate that the meeting group is for the current day.
 */
export const TodayBadge = () => <span className={todayBadgeCss}>
    <LabelText size="large">
      {I18n.t('publisher.dashboard.filters.today')}
    </LabelText>
  </span>;

require("./TodayBadge.wyw-in-js.css!=!../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./TodayBadge.tsx");